<div class="notify-flow">
  <ng-container #flow></ng-container>
</div>
